import React from 'react'
import Layout from '../../components/common/layout'
import ResidentialService from '../../components/services/residential-refrigeration'
import SEO from '../../components/common/seo'

const ResidentialServicePage = () => (
  <Layout>
    <SEO title="San Diego Refrigeration &amp; A/C Repair" />
    <ResidentialService />
  </Layout>
)

export default ResidentialServicePage
